<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
  <div
    :class="useScreenSizeObj.currentScreenSize === screenSize.MOBILE ? 'page-size-is-mobile' : useScreenSizeObj.currentScreenSize === screenSize.TABLET ? 'page-size-is-tablet' : 'page-size-is-pc'">
    <div class="background">
    </div>

    <!-- Main navbar -->
    <NavBarComp></NavBarComp>
    <!-- /main navbar -->

    <!-- Page header -->
    <HeaderComp></HeaderComp>
    <!-- /Page header -->

    <div :class="currentScreenSize !== screenSize.MOBILE ? 'page-content pt-0' : ''">
      <!-- Main sidebar -->
      <SideBarComp></SideBarComp>
      <!-- /main sidebar -->

      <!-- Main content -->
      <div class="content-wrapper">
        <!-- content -->
        <div class="content">
          <div class="row">
            <div class="col-xl-12">
              <router-view></router-view>
              <!-- <button type="button" class="btn btn-light" @click="onClickModal" >Launch <i class="ph-play-circle ms-2"></i></button> -->
              <!-- <button type="button" class="btn btn-light" @click="onClickModal">Launch <i class="ph-play-circle ms-2"></i></button> -->

            </div>
          </div>
        </div>
        <!-- /content -->
      </div>
      <!-- /main content -->
    </div>

    <!-- Footer -->
    <FooterComp></FooterComp>
    <!-- /footer -->

    <!-- /page content -->

    <!-- Notifications -->
    <NotificationAreaComp></NotificationAreaComp>
    <!-- /notifications -->

  </div>
</template>

<script>
import { useScreenSize, ScreenSize } from '@/composables/useScreenSize';
import { useCoreAuthStore } from "@/CommonVueCore/src/store/stores/authStores";
// import sweetAlert2Service from "@/services/sweetAlert2Service/sweetAlert2Service";
import SideBarComp from "@/components/layoutComponents/SideBar/SideBarComp.vue";
import App from "../../assets/js/app.js";
import HeaderComp from "@/components/layoutComponents/Header/HeaderComp.vue";
import FooterComp from "@/components/layoutComponents/Footer/FooterComp.vue";
import NavBarComp from "@/components/layoutComponents/NavBar/NavBarComp.vue";
import NotificationAreaComp from "@/components/layoutComponents/NavBar/NotificationAreaComp.vue";

import { Buttons } from "@/assets/js/pages/components_buttons.js";
import { DateTimePickers } from "@/assets/js/pages/picker_date.js";

import "@/assets/css/pages/layoutPage.css"

export default {
  data() {
    return {
      // authStoreInfos: useCoreAuthStore(),
      appSettingConfig: window.appsettings,
      useScreenSizeObj: useScreenSize(),
      screenSize: ScreenSize
    };
  },
  components: {
    SideBarComp,
    HeaderComp,
    FooterComp,
    NavBarComp,
    NotificationAreaComp,
  },
  mounted() {
    App.initCore();
    App.initAfterLoad();
    Buttons.init();
    DateTimePickers.init();
  },
  methods: {
    SignOutDeny() {
      // sweetAlert2Service.info("Info!", "Çıkış işlemi iptal edildi.");
    },
    SignOutSuccess() {
      // this.authStoreInfos.setLogOut();
      // sweetAlert2Service.info("Info!", "Başarıyla çıkış yapıldı.");
      this.$router.push({ name: "login" });
    },
    SignOut() {
      // sweetAlert2Service.confirm2(
      //   "Dikkat!",
      //   "Çıkış yapmak istediğinize emin misiniz?",
      //   this.SignOutSuccess,
      //   this.SignOutDeny
      // );
    },
    GoToDashboardPage() {
      this.$router.push({ name: "home" });
    },
    GoToUnitPage() {
      this.$router.push({ name: "unit" });
    },
    GoToUserPage() {
      this.$router.push({ name: "user" });
    },
    GoToEndPoint() {
      this.$router.push({ name: "endpoint" });
    },
    onClickModal() {

      this.$root.basicModal.ModalOpen({
        modalContentTitle: "Deneme Title XXXX",
        modalContentHtml: "<span><b>Deneme</b> Html</span>"
      })
    }
  },
  // setup() {
  //   const { currentScreenSize, ScreenSize } = useScreenSize()

  //   return {
  //     currentScreenSize,
  //     ScreenSize
  //   }
  // }
  
};
</script>
<style>
.page-size-is-pc>.page-header,
.page-size-is-tablet>.page-header {
  --page-header-padding-y: 0.5rem !important;
}

.page-size-is-mobile .page-header {
  --page-header-padding-y: 0.25rem !important;
}

.page-size-is-pc>.page-content,
.page-size-is-tablet>.page-content {}

.page-size-is-mobile .page-content {
  padding: 0;
}

.page-size-is-pc,
.page-size-is-tablet,
.page-size-is-mobile {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Sayfanın en az görünür alan kadar uzun olmasını sağlar */
}

.page-size-is-pc > .page-content,
.page-size-is-tablet > .page-content {
  flex: 1 0 auto; /* Footer'ı viewport altına itmek için ana içerik alanı büyür */
}

.page-size-is-mobile > div:not(.background):not(.page-header):not(.navbar):not(.navbar-footer) {
  flex: 1 0 auto;
}

.content-wrapper {
  flex-grow: 1; /* Bu kısım, ana içeriğin kalan tüm alanı doldurmasını sağlar */
}

.navbar-footer {
  flex-shrink: 0; /* Footer'ın küçülmesini engeller */
  margin-top: auto; /* Kısa içerikte footer'ı en alta yapıştırır */
}

.invalid-message {
  --form-validation-color: #EF4444;
  width: 100%;
  margin-top: .25rem;
  font-size: var(--body-font-size-sm);
  color: var(--form-validation-color);
}

@media (max-width: 1630px) {
  #app {
    zoom:0.8;
  }
  .page-size-is-pc,
  .page-size-is-tablet,
  .page-size-is-mobile {
    min-height: 125vh; /* 100vh / 0.8 — zoom ile küçülen yüksekliği telafi eder */
  }
}
@media (max-width: 1300px) {
  #app {
    zoom:0.7;
  }
  .page-size-is-pc,
  .page-size-is-tablet,
  .page-size-is-mobile {
    min-height: 142.86vh; /* 100vh / 0.7 */
  }
}
@media (max-width: 1023px) {
  #app {
    zoom:1;
  }
  .page-size-is-pc,
  .page-size-is-tablet,
  .page-size-is-mobile {
    min-height: 100vh;
  }
}

</style>
